function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M241.59 5.23c2.12-2.11 4.93-3.92 7.75-4.82 4.55-1.44 9.64 1.06 12.27 5.14 2.72 4.23 2.56 9.66-.5 13.67-.9 1.18-2.01 2.22-3.06 3.28-38.62 38.64-77.25 77.27-115.88 115.9-7.37 7.37-13.41 7.34-20.83-.09C82.54 99.51 43.71 60.73 5 21.82c-2.16-2.18-3.92-5.23-4.71-8.19C-.94 8.99 1.87 4.05 6.07 1.65c4.23-2.41 9.5-2.04 13.34 1.02 1.16.93 2.19 2.04 3.24 3.1 35.28 35.28 70.56 70.56 105.83 105.84.97.97 1.84 2.03 3.71 4.1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 263.54 143.91"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/down-arrow.96e9886c.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/common/images/down-arrow.svg
// module id = 491
// module chunks = 0